/**
 * Analytics hooks – fire-and-forget stubs.
 * Drop in your preferred provider (GA4, Plausible, etc.) here.
 */

const ENABLED = typeof window !== 'undefined' && import.meta.env.PROD

function track(event, payload = {}) {
  if (!ENABLED) {
    console.debug('[analytics]', event, payload)
    return
  }
  // Google Analytics 4 – example
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, payload)
  }
  // Plausible – example
  if (typeof window.plausible === 'function') {
    window.plausible(event, { props: payload })
  }
}

export const analytics = {
  pageView: (path) => track('page_view', { page_path: path }),
  convert: (provider, format, quality) =>
    track('convert', { provider, format, quality }),
  paste: (provider) => track('paste', { provider }),
  error: (provider, message) => track('error', { provider, error_message: message }),
  download: (provider, format) => track('download', { provider, format }),
}
